<bn-collapsible-section
  title="Cashflow & Financial Snapshot"
  icon="pi pi-chart-pie"
  ariaLabel="Cashflow and Financial Snapshot"
>
  @if (store.status(); as status) {
    <bn-financial-snapshot-state-badge
      sectionHeaderExtra
      [status]="status"
      [updatedAt]="badgeUpdatedAt()"
    />
  }

  @if (showDevSwitcher) {
    <div class="bn-fs-proto" role="group" aria-label="Prototype preview state">
      <span class="bn-fs-proto__label">
        <i class="pi pi-sparkles" aria-hidden="true"></i>
        PROTOTYPE — PREVIEW STATE
      </span>
      <div class="bn-fs-proto__seeds">
        @for (seed of devSeeds; track seed.id) {
          <button
            type="button"
            class="bn-fs-proto__btn"
            [class.bn-fs-proto__btn--active]="store.status() === seed.id"
            (click)="seedDev(seed.id)"
          >
            {{ seed.label }}
          </button>
        }
      </div>
    </div>
  }

  @if (store.loading()) {
    <bn-financial-snapshot-skeleton />
  } @else if (store.error()) {
    <div class="bn-fs-card__error" role="alert">
      <p>We couldn't load this client's financial snapshot.</p>
      <p-button label="Retry" severity="secondary" size="small" (onClick)="store.reload()" />
    </div>
  } @else if (!store.sessionGuid()) {
    <p class="bn-fs-card__muted">Select a client to view their financial snapshot.</p>
  } @else if (store.status() === 'empty') {
    <div class="bn-fs-card__empty">
      <p class="bn-fs-card__empty-msg">No financial snapshot yet</p>
      <div class="bn-fs-card__actions">
        <ng-container *ngTemplateOutlet="actionButtons" />
      </div>
    </div>
  } @else if (store.status() === 'in_progress') {
    <bn-financial-snapshot-progress
      [rows]="store.progressRows()"
      [enteredCount]="store.enteredRowCount()"
      [totalCount]="store.totalUiRows"
      [percent]="store.progressPercent()"
    >
      <div fsActions class="bn-fs-card__actions">
        <ng-container *ngTemplateOutlet="actionButtons" />
      </div>
    </bn-financial-snapshot-progress>
  } @else if (store.status() === 'complete' || store.status() === 'outdated') {
    @if (store.snapshot()?.metrics; as metrics) {
      <div class="bn-fs-card__grid">
        <bn-financial-snapshot-monthly-summary
          [metrics]="metrics"
          [incomeSubItems]="store.incomeSubItems()"
        >
          <div fsActions class="bn-fs-card__actions">
            <ng-container *ngTemplateOutlet="actionButtons" />
          </div>
        </bn-financial-snapshot-monthly-summary>
        <bn-financial-snapshot-spending-mix [rows]="store.spendingMixRows()" />
      </div>
    }
  }
</bn-collapsible-section>

<ng-template #actionButtons>
  <p-button
    label="Send to client"
    icon="pi pi-send"
    severity="secondary"
    [outlined]="true"
    size="small"
    (onClick)="sendToClient()"
  />
  <p-button label="Edit" icon="pi pi-pencil" size="small" (onClick)="openEdit()" />
</ng-template>
